/** Available Email-gate services to use */
export enum EmailGateEnum {
  /** "FRM" internal mailing system */
  FRM = 'FRM',
  /** "MainSMS" Email-gate service */
  MAIN_SMS = 'MAIN_SMS',
}
